module.exports = __webpack_public_path__ + "img/img2.cb4c6c42.jpg";